export enum PersonRole {
	EMPLOYEE = 'employee',
	REPRESENTATIVE = 'representative',
	DEPUTY = 'deputy',
	FINANCIAL_DATA_MANAGER = 'FinancialDataManager',
	QUALITY_MANAGER = 'QualityManager',
	RESOURCE_MANAGER = 'ResourceManager'
}
